<template>
  <div class="dialog-wrapper" style="display: inline-block;">
    <span @click="show()" :id="'addBill'+(order?order.id:'')">
      <slot></slot>
    </span>
    <el-dialog v-if="dialogFormVisible" :close-on-click-modal="false" :visible.sync="dialogFormVisible" width="50%"
               @close="init()">
<!--      <h3 class="text-center" style="margin-bottom:20px;">{{form.bill_id?'修改':'新增'}}账单</h3>-->
      <h3 class="text-center" style="margin-bottom:20px;">{{form.bill_id?'关联结算单':'新增账单'}}</h3>
      <el-form ref="form" :model="form" :rules="rules" class="dialog-form">
        <ul class="error-messages" v-if="!isEmptyErrors">
          <li v-for="error in errors">{{error[0].message}}</li>
        </ul>
        <!--<div v-if="showText" style="margin-bottom:10px;">您尚未设置提现方式. <a href="/buyer/withdraw" style="cursor: pointer;"> 现在添加.</a></div>-->
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="" prop="merchant_id">
              <el-select class="block height-50" v-model="form.merchant_id" clearable filterable
                         placeholder="商家">
                <el-option v-for="item in businessOption" :key="item.id" :label="item.merchant_name"
                           :value="item.merchant_id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="merchant_order_no">
              <YueDanIpt style="width:100%;" v-on:blur="blur" model="merchant_order_no" :object="form"
                         placeholder="商家订单号，|或逗号分隔"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="order_no_list_str">
              <YueDanIpt style="width:100%;" model="order_no_list_str" :object="form" placeholder="任务号，通过商家单号自动获取"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="" prop="fee_item_type_list">
              <el-select class="block height-50" v-model="form.fee_item_type_list" clearable filterable multiple
                         @change="changeFeeItemTypeList"
                         placeholder="费用项目">
                <el-option v-for="item in feeItemTypeList" :key="item.id" :label="item.content"
                           :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="" prop="order_amount">
              <YueDanIpt style="width:100%;" model="amount" :object="form" placeholder="计费金额" :append="form.currency"
                         :dropdownList="currencies"
                         v-on:dropdownChange="dropdownChange"
              >
              </YueDanIpt>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-col :span="12" style="padding-left: 0">
              <el-form-item label="" prop="calculating_method">
                <el-select class="block height-50" v-model="form.calculating_method" clearable filterable
                           placeholder="计费方式">
                  <el-option v-for="item in calculatingMethodList.filter(item=>!item.disabled)" :key="item.value"
                             :label="item.name"
                             :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12" style="padding-right: 0">
              <el-form-item label="" prop="calculating_method">
                <YueDanIpt type="number" v-if="form.calculating_method==1" style="width:100%;" model="percentage"
                           :object="form" placeholder="请输入百分比"/>
                <YueDanIpt type="number" v-if="form.calculating_method==2" style="width:100%;"
                           model="fixed_exchange_rate" :object="form" placeholder="请输入汇率"/>
                <YueDanIpt type="number" v-if="form.calculating_method==3" style="width:100%;" model="fixed_amount"
                           :object="form" placeholder="请输入固定金额"/>
              </el-form-item>
            </el-col>

          </el-col>

<!--          <el-col :span="12">-->
<!--            <el-form-item label="" prop="bill_status">-->
<!--              <el-select class="block height-50" v-model="form.bill_status" clearable filterable-->
<!--                         placeholder="账单状态">-->
<!--                <el-option v-for="item in billStatusList" :key="item.value"-->
<!--                           :label="item.content"-->
<!--                           :value="item.value"></el-option>-->
<!--              </el-select>-->
<!--            </el-form-item>-->
<!--          </el-col>-->
          <el-col :span="12">
            <el-form-item label="" prop="payee_user">
              <YueDanIpt style="width:100%;" model="payee_user" :object="form" placeholder="收款用户"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="bill_settlement_str">
              <el-select style="width:100%;"v-model="form.bill_settlement_no_list"
                         multiple
                         class="block height-50" placeholder="结算单号">
                <el-option
                  v-for="item in billSettlementNoList"
                  :key="item.settlement_no"
                  :label="item.settlement_no"
                  :value="item.settlement_no"></el-option>
              </el-select>
<!--              <YueDanIpt style="width:100%;" model="bill_settlement_str" :object="form" placeholder="结算单号 多个以,隔开"/>-->
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item prop="remark">
              <YueDanIpt style="width:100%;" model="remark" :object="form" placeholder="账单备注"/>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" v-if="!showText">
        <el-button class="block" type="primary" @click="submit()" :loading="loading">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
    import api from '../../../services/api.js'
    import YueDanIpt from '../../../components/YueDanIpt'
    import {CURRENCIES} from '@/services/constant'
    // import constant from '@/services/constant'
    let _ = require('lodash')


    export default {
        name: 'AddForm',
        props: ['order', 'subTotal','groupOrderLine', 'formData', 'businessOption', 'billSettlementStatusList', 'billStatusList', 'calculatingMethodList', 'feeItemTypeList', 'paymentMethodList'],
        components: {
            YueDanIpt: YueDanIpt
        },
        data() {
            return {
                billSettlementNoList:[],
                orderRate: 1,
                currencies: [],
                dialogFormVisible: false,
                loading: false,
                errors: null,
                list: null,
                showText: false,
                isEmptyErrors: true,
                form: {},
                businessCurrency: '',
                rules: {
                    merchant_id: [
                        {required: true, message: '商家必填', trigger: 'change'}
                    ],
                    merchant_order_no: [
                        {required: true, message: '商家订单号必填，', trigger: 'change'}
                    ],
                    order_no: [
                        {required: true, message: '任务号必填', trigger: 'change'}
                    ],
                    calculating_method: [
                        {required: true, message: '计算方式必填', trigger: 'change'}
                    ],
                    amount: [
                        {required: true, message: '计费金额必填', trigger: 'change'}
                    ],
                    currency: [
                        {required: true, message: '货币符合必填', trigger: 'change'}
                    ],
                    fee_item_type_list: [
                        {required: true, message: '费用项目必填', trigger: 'change'}
                    ],
                    payee_user: [
                        {required: true, message: '收款用户必填', trigger: 'change'}
                    ],
                }
            }
        },
        methods: {
            init() {
                let userName=''
               if(this.order&&this.order.groupOrderLines){
                Object.keys(this.order.groupOrderLines).map(item=>{
                 if(!userName){
                     let _username= this.order.groupOrderLines[item][0].payment_username;
                     userName=_username;
                 }
                })
               }
                this.form = {
                    merchant_id: this.order ? this.order.business_id : '',
                    merchant_order_no: this.order ? this.order.business_order_no : '',
                    order_no_list_str: this.order ? this.order.order_no : '',
                    amount:this.subTotal&&this.subTotal.subtotal_price? this.subTotal.subtotal_price.value:'',
                    fee_item_type_list: [1],
                    calculating_method: '',
                    currency: this.subTotal&&this.subTotal.subtotal_price?this.subTotal.subtotal_price.currency:'',
                    payee_user: userName,
                    bill_status: '0',
                    bill_settlement_str: '',
                    calculating_method_detail: '',
                    remark: '',
                }
                this.isEmptyErrors = true;
                this.handleCurrency();
            },
            dropdownChange(currency) {
                if(currency){
                    this.form.currency=currency.value;
                }
            },
            handleCurrency(){
                if(!(this.subTotal&&this.subTotal.subtotal_price)){
                    return
                }
                let currency=this.subTotal.subtotal_price.currency
                let cny = CURRENCIES.find(item => item.value == 'CNY');
                let defaultCu = CURRENCIES.find(item => item.value == currency);
                let other = CURRENCIES.filter(i => {
                    return i.value != 'CNY' && i.value != currency;
                });
                this.currencies = [ defaultCu,cny, ...other];
                if (cny == defaultCu) {
                    this.currencies = [defaultCu, ...other];
                }
                this.orderRate=this.subTotal.rate;
                this.form.fixed_exchange_rate=this.orderRate;
            },
            changeFeeItemTypeList(v) {
                this.form.calculating_method = '';
                this.calculatingMethodList.map(item => {
                    item.disabled = true;
                })
                if (v.length === 0) {

                } else if (v.length == 1 && v[0] == 1) {
                    this.calculatingMethodList.map(item => {
                        if (item.value != 3) {
                            item.disabled = false;
                        }
                    })
                } else {
                    this.form.calculating_method = 3;
                    this.calculatingMethodList.map(item => {
                        if (item.value == 3) {
                            item.disabled = false;
                        }
                    })
                }
            },
            blur(v) {
                // let orderNo = v.replace(" ", ",").replace("，", ",").replace("|",",");
                // if (!orderNo) {
                //     return;
                // }
                // let params = {keyword_type: '2', keyword: orderNo};
                // api.getSingleOrders(this, params).then(res => {
                //     if (res.body.result && res.body.result.length) {
                //         let orderNo = '';
                //         let currency = '';
                //         let totalRmb = 0;
                //         let orderRate = "";
                //         res.body.result.map(item => {
                //             orderNo += ',' + item.order_no;
                //             currency += ',' + item.business.default_currency;
                //             totalRmb += Number(item.original_rmb_total_amount);
                //             orderRate = item.conditions.rate;
                //         });
                //         this.orderRate = orderRate;
                //         this.form.order_amount = totalRmb.toFixed(2)
                //         this.form.order_no_list_str = orderNo.substring(1);
                //         let temparr = currency.substring(1).split(",");
                //         if (temparr.length == 1) {
                //             let cny = CURRENCIES.find(item => item.value == 'CNY');
                //             let defaultCu = CURRENCIES.find(item => item.value == temparr[0]);
                //             let other = CURRENCIES.filter(i => {
                //                 return i.value != 'CNY' && i.value != v;
                //             });
                //             this.currencies = [cny, defaultCu, ...other];
                //             if (cny == defaultCu) {
                //                 this.currencies = [defaultCu, ...other];
                //             }
                //         }
                //     }
                // })
            },
          async show() {
                this.dialogFormVisible = true;
                this.init();
                let res = await api.getBillSettlementList(this, {bill_settlement_status:1,page:1,limit:500});
                this.billSettlementNoList=res.body.result
            },
            submit() {
                this.$refs['form'].validate(async (valid, errors) => {
                    this.isEmptyErrors = _.isEmpty(errors)
                    this.errors = errors;
                    let param = JSON.parse(JSON.stringify(this.form));
                    let temp = param.merchant_order_no.split("|");
                    let merchant_order_info_list = [];
                    temp.map(item => {
                        let a = {merchant_id: param.merchant_id, merchant_order_no: item};
                        merchant_order_info_list.push(a);
                    });

                    param.merchant_order_info_list = merchant_order_info_list;
                    // param.bill_settlement_no_list = param.bill_settlement_str.split("|");

                    if (param.calculating_method == 1) {
                        param.calculating_method_detail = {
                            order_amount: param.amount,
                            order_rate: this.orderRate,
                            percentage: (this.form.percentage / 100).toFixed(2),
                        }
                    } else if (param.calculating_method == 2) {
                        param.calculating_method_detail = {
                            fixed_exchange_rate: param.fixed_exchange_rate,
                        }
                    } else if (param.calculating_method == 3) {
                        param.calculating_method_detail = {
                            fixed_amount: param.fixed_amount,
                        }
                    }

                    param.order_no_list = param.order_no_list_str.split("|");//任务单号
                    if (valid) {
                        this.loading = true;
                        let res;
                        if (!this.form.bill_id) {
                            res = await api.addBill(this, param)
                        } else {
                            res = await api.updateBill(this, param)
                        }
                        this.loading = false
                        if (res.body.status == 'ok') {
                            this.$emit('addBillBack')
                            this.dialogFormVisible = false
                        }
                    } else {
                        return false
                    }
                })
            },
        },
        watch: {
            formData(v) {
                if (v.bill_id) {
                    this.form = v;
                    this.form.order_no_list_str = v.order_no_list.join('|');
                    this.form.merchant_id = (v.merchant_order_info_list[0].merchant_id);
                    this.form.merchant_order_no = v.merchant_order_info_list.map(item => {
                        return item.merchant_order_no
                    }).join('|');
                    this.form.fee_item_type_list = v.fee_item_type_list.map(item => {
                        return Number(item);
                    });
                    this.form.bill_status = Number(v.bill_status)
                    this.form.calculating_method = Number(v.calculating_method);

                    if (v.calculating_method_detail.fixed_exchange_rate) {
                        this.form.fixed_exchange_rate = v.calculating_method_detail.fixed_exchange_rate
                    }

                    if (v.calculating_method_detail.percentage) {
                        this.form.percentage = v.calculating_method_detail.percentage*100
                    }
                    if (v.calculating_method_detail.fixed_amount) {
                        this.form.fixed_amount = v.calculating_method_detail.fixed_amount;
                    }
                    if(v.bill_settlement_no_list&&v.bill_settlement_no_list.list){
                        this.form.bill_settlement_str=v.bill_settlement_no_list.join(',');
                    }
                }
            },
        }
    }
</script>

<style lang="scss" scoped>
  .form-item {
    display: flex;
    justify-content: space-between;
  }

  .detail-table-head {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #D7D7D7;
    padding-bottom: 10px;
  }

  .detail-table-body {
    max-height: 300px;
    overflow: auto;
  }

  .detail-table-row {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #D7D7D7;
    padding: 10px 0;
    align-items: center;

    &:last-child {
      border-bottom: none;
      padding-bottom: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/orders/amount_bill/Create.vue